module.exports = __webpack_public_path__ + "img/zhanneixin.22f50974.png";